/* Page Média par BESOIN (thème Shopify) : COPIE GÉNÉRÉE de js/media-besoins-core.js (ne pas modifier ici : régénérer depuis la maquette). Le balisage est rendu par Liquid (sections/mi-media-besoins.liquid, snippets/mi-media-card.liquid).
   Rien n'est chargé avant le clic : la vidéo (youtube-nocookie) et l'audio (élément <audio> en preload none) sont créés au clic ; un seul lecteur actif sur toute la page.
   Fait : barre de besoins collante (surbrillance du besoin en cours), filtre de format en place (Tout / Vidéo / Audio / Entretien, masqué si un seul format), « Voir plus » / « Réduire », annonce du nombre de contenus (aria-live).
   Balisage attendu : [data-mb] (libellés en data-l-*, data-visible-small / data-visible-large) > [data-mb-bar] a[href="#id"] ; [data-mb-need] > ul.mb-list > li.mb-card[data-id][data-formats][data-yt][data-audio][data-title][data-cc]. */
(() => {
  if (window.__miMediaBesoins) return;
  window.__miMediaBesoins = true;
  function enhance(root) {
    if (!root || root.dataset.mbInit) return;
    root.dataset.mbInit = '1';
    const L = root.dataset;
    const reduce = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
    const lang = () => ((document.documentElement.lang || 'fr').slice(0, 2) === 'fr' ? 'fr' : 'en');
    const esc = (s) => String(s ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    const fill = (tpl, k, v) => String(tpl || '').replace(k, v);
    const saved = new WeakMap();
    let active = null;   // { card, kind }

    const embed = (id, cc) => `https://www.youtube-nocookie.com/embed/${encodeURIComponent(id)}?autoplay=1&rel=0&modestbranding=1&playsinline=1&hl=${lang()}${cc ? '&cc_load_policy=1&cc_lang_pref=fr' : ''}`;

    /* ---------- Lecteurs : un seul actif ---------- */
    function stop() {
      if (!active) return;
      const { card, kind } = active;
      active = null;
      card.classList.remove('is-playing', 'is-listening');
      if (kind === 'video') {
        const frame = card.querySelector('[data-mb-frame]');
        if (frame && saved.has(card)) frame.innerHTML = saved.get(card);
      } else {
        const host = card.querySelector('[data-mb-audio]');
        if (host) { host.querySelectorAll('audio').forEach((a) => { try { a.pause(); } catch (e) { /* absent */ } }); host.innerHTML = ''; host.hidden = true; }
      }
      card.querySelectorAll('[data-mb-act="audio"][aria-pressed]').forEach((b) => b.setAttribute('aria-pressed', 'false'));
    }

    function playVideo(card) {
      const id = card.dataset.yt; if (!id) return;
      const frame = card.querySelector('[data-mb-frame]'); if (!frame) return;
      document.dispatchEvent(new CustomEvent('mi:media-start', { detail: 'youtube' }));
      stop();
      document.querySelectorAll('audio, video').forEach((m) => { if (!(m.muted && m.loop)) { try { m.pause(); } catch (e) { /* absent */ } } });
      if (!saved.has(card)) saved.set(card, frame.innerHTML);
      frame.innerHTML = `<iframe src="${embed(id, card.hasAttribute('data-cc'))}" title="${esc(card.dataset.title)}" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen referrerpolicy="strict-origin-when-cross-origin"></iframe>`;
      card.classList.add('is-playing');
      active = { card, kind: 'video' };
      const r = frame.getBoundingClientRect();
      const top = (document.querySelector('[data-mb-bar]')?.getBoundingClientRect().bottom || 70) + 8;
      if (r.top < top || r.bottom > innerHeight) frame.scrollIntoView({ block: 'center', behavior: reduce() ? 'auto' : 'smooth' });
      frame.querySelector('iframe')?.focus({ preventScroll: true });
    }

    function playAudio(card) {
      const url = card.dataset.audio; if (!url) return;
      const host = card.querySelector('[data-mb-audio]'); if (!host) return;
      const was = active && active.card === card && active.kind === 'audio';
      if (was) { stop(); return; }
      document.dispatchEvent(new CustomEvent('mi:media-start', { detail: 'podcast' }));
      stop();
      document.querySelectorAll('audio, video').forEach((m) => { if (!(m.muted && m.loop)) { try { m.pause(); } catch (e) { /* absent */ } } });
      const a = document.createElement('audio');
      a.controls = true; a.preload = 'none'; a.src = url;
      a.setAttribute('aria-label', fill(L.lAudio, '__TITLE__', card.dataset.title));
      host.innerHTML = ''; host.appendChild(a); host.hidden = false;
      card.classList.add('is-listening');
      card.querySelectorAll('[data-mb-act="audio"][aria-pressed]').forEach((b) => b.setAttribute('aria-pressed', 'true'));
      active = { card, kind: 'audio' };
      const p = a.play(); if (p && p.catch) p.catch(() => { /* lecture refusée : les commandes restent visibles */ });
    }

    root.addEventListener('click', (e) => {
      const b = e.target.closest('[data-mb-act]');
      if (!b || !root.contains(b)) return;
      const card = b.closest('.mb-card'); if (!card) return;
      if (b.tagName === 'A') e.preventDefault();
      if (b.dataset.mbAct === 'video') { if (!(active && active.card === card && active.kind === 'video')) playVideo(card); } else playAudio(card);
    });
    document.addEventListener('play', (e) => { if (e.target instanceof HTMLMediaElement && !(e.target.muted && e.target.loop) && active && active.kind === 'video') stop(); }, true);

    /* ---------- Filtres de format + Voir plus, par besoin ---------- */
    const FMT = ['video', 'audio', 'entretien'];
    const wide = matchMedia('(min-width: 1000px)');
    const limit = () => (wide.matches ? +L.visibleLarge || 6 : +L.visibleSmall || 4);
    const needs = [...root.querySelectorAll('[data-mb-need]')].map((el) => {
      const cards = [...el.querySelectorAll('.mb-card')];
      const has = (c, f) => (c.dataset.formats || '').split(/\s+/).includes(f);
      const counts = Object.fromEntries(FMT.map((f) => [f, cards.filter((c) => has(c, f)).length]));
      const st = { el, cards, has, counts, fmt: 'all', open: false };
      const list = el.querySelector('.mb-list');
      // filtre : seulement si au moins deux formats existent dans ce besoin
      const kinds = FMT.filter((f) => counts[f] > 0);
      const tools = document.createElement('div'); tools.className = 'mb-tools';
      if (kinds.length > 1 && !('noFilter' in root.dataset)) {
        const lab = { all: L.lAll, video: L.lVideo, audio: L.lAudioTag, entretien: L.lEntretien };
        const mk = (f, n) => `<button type="button" class="mb-chip" data-mb-f="${f}" aria-pressed="${f === 'all' ? 'true' : 'false'}">${esc(lab[f])} <span class="mb-chip__n">${n}</span></button>`;
        tools.innerHTML = `<div class="mb-filter" role="group" aria-label="${esc(L.lFilter)}">${mk('all', cards.length)}${kinds.map((f) => mk(f, counts[f])).join('')}</div>`;
        list.before(tools);
        tools.addEventListener('click', (e) => {
          const b = e.target.closest('[data-mb-f]'); if (!b) return;
          st.fmt = b.dataset.mbF; st.open = false;
          tools.querySelectorAll('[data-mb-f]').forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
          apply(st);
        });
      }
      const more = document.createElement('p'); more.className = 'mb-more'; more.hidden = true;
      more.innerHTML = '<button type="button" class="mb-morebtn" aria-expanded="false"></button>';
      list.after(more);
      const status = document.createElement('p'); status.className = 'mb-sr'; status.setAttribute('role', 'status'); status.setAttribute('aria-live', 'polite');
      more.after(status);
      st.more = more; st.btn = more.firstChild; st.status = status;
      st.btn.addEventListener('click', () => { st.open = !st.open; apply(st, true); });
      return st;
    });

    function apply(st, keepFocus) {
      const ok = st.cards.filter((c) => st.fmt === 'all' || st.has(c, st.fmt));
      const n = limit();
      const shown = st.open ? ok : ok.slice(0, n);
      st.cards.forEach((c) => {
        const show = shown.includes(c);
        if (!show && c.hidden === false && active && active.card === c) stop();
        c.hidden = !show;
      });
      const extra = ok.length - n;
      st.more.hidden = extra <= 0;
      st.btn.textContent = st.open ? L.lLess : fill(L.lMore, '__N__', extra);
      st.btn.setAttribute('aria-expanded', String(st.open));
      st.status.textContent = fill(L.lCount, '__N__', shown.length);
      if (keepFocus) st.btn.focus({ preventScroll: true });
    }
    needs.forEach((st) => apply(st));
    wide.addEventListener('change', () => needs.forEach((st) => apply(st)));

    /* ---------- Barre de besoins : besoin en cours ---------- */
    const bar = root.querySelector('[data-mb-bar]');
    if (bar && 'IntersectionObserver' in window) {
      const links = [...bar.querySelectorAll('a[href^="#"]')];
      const map = new Map(links.map((a) => [a.getAttribute('href').slice(1), a]));
      const set = (id) => {
        links.forEach((a) => { const on = a === map.get(id); a.classList.toggle('is-active', on); if (on) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current'); });
        const a = map.get(id), sc = bar.querySelector('.mb-bar__scroll');
        if (a && sc && sc.scrollWidth > sc.clientWidth) sc.scrollTo({ left: Math.max(0, a.offsetLeft - 24), behavior: reduce() ? 'auto' : 'smooth' });
      };
      const seen = new Map();
      const io = new IntersectionObserver((es) => {
        es.forEach((x) => seen.set(x.target.id, x.isIntersecting));
        const first = [...map.keys()].find((id) => seen.get(id));
        set(first || '');
      }, { rootMargin: '-30% 0px -60% 0px' });
      map.forEach((a, id) => { const s = document.getElementById(id); if (s) io.observe(s); });
    }
    const fade = bar?.querySelector('.mb-bar__scroll');
    if (fade) {
      const wrap = fade.parentElement;
      const upd = () => wrap.classList.toggle('is-end', fade.scrollLeft + fade.clientWidth >= fade.scrollWidth - 4);
      fade.addEventListener('scroll', upd, { passive: true }); addEventListener('resize', upd); upd();
    }
  }
  const init = (scope) => (scope || document).querySelectorAll('[data-mb]').forEach((r) => { delete r.dataset.mbInit; enhance(r); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
